/** @format — Shipment panel chat loading placeholders (no Dockie avatar) */

import React from "react";

export default function ShipmentChatSkeleton() {
  return (
    <div className="space-y-4 animate-pulse" aria-hidden>
      <div className="flex justify-end">
        <div className="h-11 w-[min(65%,200px)] bg-[#E4E7EC] rounded-2xl rounded-br-sm" />
      </div>
      <div className="flex justify-start max-w-[85%]">
        <div className="flex flex-col gap-3 w-full">
          <div className="h-36 w-full bg-[#F2F4F7] rounded-xl border border-[#E4E7EC]" />
          <div className="h-14 w-[min(100%,280px)] bg-[#E4E7EC] rounded-2xl rounded-bl-sm" />
        </div>
      </div>
      <div className="flex justify-end">
        <div className="h-10 w-[min(55%,160px)] bg-[#E4E7EC] rounded-2xl rounded-br-sm" />
      </div>
    </div>
  );
}
